import percent from './percent';
import number from './number';
import currency from './currency';
import type { FormatterArgs } from '@/services/types/formatter';

export default (params: FormatterArgs) => {
  switch (params.format) {
    case 'percent':
      return percent(params);
    case 'number':
      return number(params);
    case 'currency':
      return currency(params);
    default:
      return number(params);
  }
};
